// extracted by mini-css-extract-plugin
export default {"buttonPremium":"ButtonPremium_buttonPremium__l5Btt"};